import script from "./maintenanceReportDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./maintenanceReportDetails.vue?vue&type=script&lang=ts&setup=true"

import "./maintenanceReportDetails.vue?vue&type=style&index=0&id=3c146260&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c146260"]])

export default __exports__